export { LangSwitcher } from './lang-switcher';
